export default __webpack_public_path__ + "static/media/dados-figura4.ae86fa42.png";